import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetlocation } from "../../store/api/locationApi";

function RoleList({ onEdit }) {
  const getLocation = useGetlocation();
  const {
    data: locationData,
    isLoading: isLocationLoading,
    error: locationError,
  } = useQuery({ queryKey: "location", queryFn: getLocation });

  const data = locationData?.division
    ?.map((role, index) => ({
      index: index + 1,
      name: role?.name,
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Division",
      accessor: "name",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isLocationLoading} />
    </div>
  );
}

export default RoleList;
